import PropTypes from 'prop-types';

const ProgressBar = ({ label, value = 0, rightLabel }) => {
  const intValue = Math.round(Number(value));

  return (
    <div>
      {label && <p>{label}</p>}
      <progress className="progress progress-info w-full" value={intValue} max="100"></progress>
      <div className="flex justify-between">
        <p className="text-xs">{intValue}% complete</p>
        {rightLabel && <p className="text-xs text-gray-500">{rightLabel}</p>}
      </div>
    </div>
  );
};

export default ProgressBar;

ProgressBar.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string,
  rightLabel: PropTypes.string,
};
